import colors from '../colors'
import palette from './palette'

const borderColorBright = '#ccc'
const bodyBackgroundColor = colors['color-page-background--solid']
const mainBackgroundColor = colors['color-background-primary']
const dimBackgroundColor = colors['color-background-primary--dim']
const dimTextColor = colors['text--deemphasis']
const mainTextColor = colors.text
const dangerColor = colors['action-destructive']
const successColor = colors['feedback--success']

export const theme = {
  name: 'light',

  colors,
  palette,

  mainBackgroundColor,
  mainTextColor,
  dimTextColor,
  dangerColor,
  successColor,
  bodyBackgroundColor,

  amcharts: {
    colorList: [
      '#C74A37',
      '#5F986A',
      '#965AA9',
      '#4A9BBC',
      '#DE8E47',
      '#C24976',
      '#F0DF6D',
      '#73C4AC',
      '#939FB2',
    ],
    pieSeriesStroke: colors['color-background-primary'],
    mapFill: '#dddddd',
    MapPolygonSeries: {
      fill: '#dddddd',
      stroke: '#999999',
    },
    heatPalettes: {
      danger: {
        stroke: '#dd0000',
        min: '#ddaaaa',
        max: '#aa0000',
      },
      source: {
        stroke: '#40004B',
        min: palette.purple4,
        max: palette.purple1,
      }
    },
    legend: {
      border: `1px solid ${mainTextColor}`,
      backgroundColor: palette.dimBackground,
    },
    confidenceColors: {
      low: '#FEE5D9',
      medium: '#EF3B2C',
      high: '#67000D',
    }
  },

  articlesWidget: {
    item: {
      backgroundColor: dimBackgroundColor,
      borderColor: borderColorBright,
      color: mainTextColor,
    },
    itemDate: {
      color: dimTextColor,
    }
  },

  avatar: {
    backgroundColor: colors['color-background-secondary'],
    color: colors.text,
  },

  body: {
    backgroundColor: bodyBackgroundColor,
    color: mainTextColor,
  },

  button: {
    primary: {
      backgroundColor: colors['action-primary'],
      color: colors['text--reverse'],
      ':hover': {
        color: colors['text--reverse'],
        backgroundColor: colors['action-primary--deemphasis'],
      },
      ':active': {
        color: colors['text--reverse'],
        backgroundColor: colors['action-primary--emphasis'],
      },
      ':disabled': {
        color: colors['text--reverse'],
        backgroundColor: colors['action-secondary'],
        cursor: 'default',
      },
    },

    'primary-transparent': {
      color: colors['action-primary'],
      ':hover': {
        color: colors['action-primary--deemphasis'],
      },
      ':active': {
        color: colors['action-primary--emphasis'],
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    secondary: {
      color: colors['action-secondary'],
      borderColor: colors['action-secondary'],
      ':hover': {
        color: colors['action-secondary--deemphasis'],
        borderColor: colors['action-secondary--deemphasis'],
      },
      ':active': {
        color: colors['action-secondary--emphasis'],
        borderColor: colors['action-secondary--emphasis'],
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    'secondary-transparent': {
      color: colors['action-secondary'],
      ':hover': {
        color: colors['action-secondary--deemphasis'],
      },
      ':active': {
        color: colors['action-secondary--emphasis'],
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    danger: {
      backgroundColor: colors['action-destructive'],
      color: colors['text--reverse'],
      ':hover': {
        backgroundColor: colors['action-destructive--deemphasis'],
      },
      ':active': {
        backgroundColor: colors['action-destructive--emphasis'],
      },
    },

    'danger-transparent': {
      color: colors['action-destructive'],
      ':hover': {
        color: colors['action-destructive--deemphasis'],
      },
      ':active': {
        color: colors['action-destructive--emphasis'],
      },
    },

    outline: {
      color: colors['action-secondary'],
      borderColor: colors['action-secondary'],
      backgroundColor: colors.transparent,
      ':hover': {
        color: colors['action-primary'],
        borderColor: colors['action-primary'],
        backgroundColor: colors.transparent,
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    plain: {
    },

    unstyled: {
      color: 'inherit',
      background: 'none',
      margin: 0,
      padding: 0,
      border: 0,
      ':disabled': {
        cursor: 'not-allowed',
      },
    },

    'unstyled-block': {
      display: 'block',
      textAlign: 'left',
      width: '100%',
      color: 'inherit',
      background: 'none',
      margin: 0,
      padding: 0,
      border: 0,
      ':disabled': {
        cursor: 'not-allowed',
      },
    }
  },

  cve: {
    default: {
      color: colors.text
    },
    low: {
      color: colors['risk--low']
    },
    medium: {
      color: colors['risk--medium']
    },
    high: {
      color: colors['risk--high']
    },
    critical: {
      color: colors['risk--critical']
    },
    none: {
      color: colors['risk--benign']
    },
    easy: {
      color: colors['risk--low']
    },
    moderate: {
      color: colors['risk--medium']
    },
    difficult: {
      color: colors['risk--high']
    },
  },

  dropdown: {
    trigger: {
      ':hover': {
        backgroundColor: colors['color-background-primary--dim']
      }
    },
    list: {
      background: dimBackgroundColor,
      boxShadow: '0 16px 40px rgba(0, 0, 0, 0.4)',
      borderColor: colors.text,
    },
    item: {
      ':hover': {
        backgroundColor: colors['color-background-primary--bright']
      }
    },
    hr: {
      borderColor: 'rgba(255, 255, 255, 0.15)',
    },
    button: {
      default: {
        color: mainTextColor,
      },
      hover: {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
      }
    }
  },

  link: {
    default: {
      color: colors['active-primary'],
    },
    hover: {}
  },

  loader: {
    ringColor: 'rgb(215, 215, 215)',
    barColor: 'rgb(68, 68, 68)',
  },

  modal: {
    backgroundColor: colors['color-background-primary'],
    borderColor: dimTextColor,
    color: mainTextColor,
    ribbonBackground: '#c0cad8',
    headerBackgroundColor: '#222',
  },

  navbar: {
    base: {
      color: colors.text,
      backgroundColor: colors['color-background-primary'],
      borderColor: colors.border,
      activeColor: colors['active-primary'],
    },
    ribbonBackground: '#c0cad8',
    menuItemUnderline: colors['active-primary'],
    profile: {
      backgroundColor: colors['color-background-primary'],
    },
  },

  panel: {
    backgroundColor: colors['color-background-primary'],
  },

  pill: {
    default: {
      backgroundColor: palette.gray8,
      color: palette.gray7,
    },
    danger: {
      backgroundColor: palette.red2,
      color: mainTextColor,
    },
    dim: {
      backgroundColor: palette.gray3,
      color: mainTextColor,
    },
  },

  scrollbar: {
    color: 'rgba(0, 0, 0, 0.2)',
  },

  searchInput: {
    backgroundColor: '#f0f0f0',
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.7)',
    borderColor: 'transparent',
    color: mainTextColor,
  },

  textInput: {
    backgroundColor: '#f0f0f0',
    borderColor: '#ccc',
    color: mainTextColor,
  },

  widget: {
    header: {
      backgroundColor: colors['color-background-primary'],
      color: mainTextColor,
    },

    content: {
      backgroundColor: colors['color-background-primary'],
      color: mainTextColor,
    }
  },

  tooltip: {
    backgroundColor: palette.gray6,
    color: mainTextColor,
    borderColor: palette.gray7,
  },

  freemium: {
    lock: {
      color: colors['freemium-lock']
    }
  }
}

export default theme
